var _path, _circle, _circle2, _circle3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 175,
    viewBox: "0 0 174 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.5833 167.083C130.536 167.083 166.167 131.452 166.167 87.4998C166.167 43.5472 130.536 7.9165 86.5833 7.9165C42.6307 7.9165 7 43.5472 7 87.4998C7 131.452 42.6307 167.083 86.5833 167.083Z",
    stroke: "url(#paint0_linear_32988_57939)",
    strokeWidth: 14
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5833,
    cy: 87,
    r: 7,
    fill: "url(#paint1_linear_32988_57939)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5833,
    cy: 87,
    r: 7,
    fill: "url(#paint2_linear_32988_57939)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.583,
    cy: 87,
    r: 7,
    fill: "url(#paint3_linear_32988_57939)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32988_57939",
    x1: 13.6747,
    y1: 15.0081,
    x2: 358.573,
    y2: 138.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0185FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32988_57939",
    x1: 51.1704,
    y1: 80.6238,
    x2: 81.507,
    y2: 91.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0185FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32988_57939",
    x1: 80.1704,
    y1: 80.6238,
    x2: 110.507,
    y2: 91.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0185FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32988_57939",
    x1: 109.17,
    y1: 80.6238,
    x2: 139.507,
    y2: 91.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0185FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.c83a2436.svg";
export { ForwardRef as ReactComponent };